(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anie-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.AnieWishlist) return;
  const root = document.getElementById('anie-wishlist-root');
  if (!root) return;
  const strings = JSON.parse(root.querySelector('[data-anie-wish-strings]').textContent);
  const storageKey = 'anie:wishlist:v1';
  const list = document.getElementById('anie-wish-list');
  const confirm = document.getElementById('anie-wish-remove');
  const status = root.querySelector('[data-anie-wish-status]');
  let pendingKey = null;
  let busy = false;
  let timer;
  let opener;
  function read() {
    const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(value)) throw new Error(strings.storage_error);
    return value.filter(item => item && /^\d+$/.test(String(item.id)) && /^[a-zA-Z0-9_-]+$/.test(item.handle)).slice(0,200);
  }
  function write(items) {
    localStorage.setItem(storageKey, JSON.stringify(items));
    refresh();
  }
  function save(item) {
    const items = read();
    if (items.some(saved => String(saved.id) === String(item.id))) return;
    if (items.length >= 200) throw new Error(strings.limit_error);
    write([...items, item]);
  }
  function announce(message) {
    clearTimeout(timer);
    status.textContent = message;
    status.hidden = false;
    timer = setTimeout(() => { status.hidden = true; }, 5500);
  }
  function selectedId(button) {
    const input = button.closest('.buy-buttons-block')?.querySelector('input[name="id"]');
    return input ? input.value : button.dataset.variantId;
  }
  function refresh() {
    let items = [];
    try { items = read(); } catch {}
    document.querySelectorAll('[data-anie-wish-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-label', strings.title + ' (' + items.length + ')');
      button.querySelector('[data-anie-wish-count]').textContent = items.length;
    });
    document.querySelectorAll('[data-anie-wish-save]').forEach(button => {
      button.hidden = false;
      const saved = items.some(item => String(item.id) === String(selectedId(button)));
      button.setAttribute('aria-pressed', String(saved));
      button.querySelector('[data-anie-wish-label]').textContent = saved ? strings.saved : strings.save;
    });
  }
  function show(dialog, source) {
    opener = source || document.activeElement;
    dialog.querySelector('[data-anie-wish-error]').textContent = '';
    dialog.showModal();
  }
  function renderList() {
    const container = list.querySelector('[data-anie-wish-items]');
    container.replaceChildren();
    const items = read();
    list.querySelector('[data-anie-wish-empty]').hidden = items.length > 0;
    items.forEach(item => {
      const row = document.createElement('li');
      row.className = 'anie-wish-item';
      const url = root.dataset.rootUrl + 'products/' + encodeURIComponent(item.handle) + '?variant=' + encodeURIComponent(item.id);
      const image = document.createElement('img');
      image.alt = item.title + (item.shade ? ' - ' + item.shade : '');
      image.width = 90; image.height = 112; image.loading = 'lazy';
      try {
        const src = new URL(item.image, location.origin);
        if (src.protocol === 'https:' && (src.origin === location.origin || src.hostname === 'cdn.shopify.com')) image.src = src.href;
      } catch {}
      const details = document.createElement('div');
      const heading = document.createElement('h3');
      const link = document.createElement('a');
      link.href = url; link.textContent = item.title; heading.append(link);
      const shade = document.createElement('p');
      shade.textContent = item.shade;
      const view = document.createElement('a');
      view.href = url; view.className = 'anie-wish-action'; view.textContent = strings.view;
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'anie-wish-delete'; remove.textContent = strings.remove_saved;
      remove.setAttribute('aria-label', strings.remove_saved + ': ' + item.title + (item.shade ? ', ' + item.shade : ''));
      remove.addEventListener('click', () => {
        try {
          write(read().filter(saved => String(saved.id) !== String(item.id)));
          renderList();
          list.querySelector('[data-anie-wish-close]').focus();
        } catch { list.querySelector('[data-anie-wish-error]').textContent = strings.storage_error; }
      });
      details.append(heading,shade,view,remove);
      row.append(image,details); container.append(row);
    });
  }
  async function json(url, options) {
    const response = await fetch(url, { ...options, signal:AbortSignal.timeout(15000), headers:{Accept:'application/json', ...options?.headers} });
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(strings.network_error);
    return data;
  }
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-anie-wish-open]');
    if (open) {
      show(list, open);
      try { renderList(); } catch { list.querySelector('[data-anie-wish-error]').textContent = strings.storage_error; }
      return;
    }
    const button = event.target.closest('[data-anie-wish-save]');
    if (!button || button.disabled) return;
    const id = selectedId(button);
    if (!id) { announce(strings.select_shade); return; }
    button.disabled = true;
    try {
      const items = read();
      if (items.some(item => String(item.id) === String(id))) {
        write(items.filter(item => String(item.id) !== String(id)));
        announce(strings.removed);
      } else {
        const product = await json(button.dataset.productUrl + '.js');
        const variant = product.variants.find(item => String(item.id) === String(id));
        if (!variant) throw new Error(strings.select_shade);
        save({id:String(id),handle:product.handle,title:product.title,shade:variant.title === 'Default Title' ? '' : variant.title,image:variant.featured_image?.src || product.featured_image || ''});
        announce(strings.saved_notice);
      }
    } catch (error) {
      announce(error.name === 'QuotaExceededError' || error.name === 'SecurityError' || error instanceof SyntaxError ? strings.storage_error : error.message || strings.network_error);
    } finally { button.disabled = false; refresh(); }
  });
  root.querySelectorAll('[data-anie-wish-close]').forEach(button => button.addEventListener('click', () => {
    if (!busy) button.closest('dialog').close();
  }));
  [list,confirm].forEach(dialog => {
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    dialog.addEventListener('close', () => { pendingKey = null; if (opener?.isConnected) opener.focus(); });
    dialog.addEventListener('click', event => {
      if (busy || event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
  });
  confirm.querySelectorAll('[data-anie-wish-confirm]').forEach(button => button.addEventListener('click', async () => {
    if (busy || !pendingKey) return;
    busy = true;
    confirm.querySelectorAll('button').forEach(control => { control.disabled = true; });
    const errorBox = confirm.querySelector('[data-anie-wish-error]');
    errorBox.textContent = '';
    try {
      const cart = await json(root.dataset.rootUrl + 'cart.js');
      const item = cart.items.find(line => line.key === pendingKey);
      if (!item) throw new Error(strings.cart_changed);
      if (button.dataset.anieWishConfirm === 'save') {
        try {
          save({id:String(item.variant_id),handle:item.handle,title:item.product_title,shade:item.variant_title === 'Default Title' ? '' : item.variant_title || '',image:item.featured_image?.url || item.image || ''});
        } catch (error) { throw new Error(error.message === strings.limit_error ? strings.limit_error : strings.storage_error); }
      }
      await json(root.dataset.rootUrl + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:pendingKey,quantity:0})});
      location.reload();
    } catch (error) {
      errorBox.textContent = error.message || strings.network_error;
      busy = false;
      confirm.querySelectorAll('button').forEach(control => { control.disabled = false; });
    }
  }));
  window.AnieWishlist = {
    requestRemove(key) {
      if (!key) return false;
      if (confirm.open) return true;
      pendingKey = key;
      show(confirm);
      return true;
    }
  };
  document.addEventListener('variant:update', () => requestAnimationFrame(refresh));
  document.addEventListener('change', () => requestAnimationFrame(refresh));
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', event => {
    if (event.key === storageKey || event.key === null) {
      refresh();
      if (list.open) { try { renderList(); } catch {} }
    }
  });
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
